import { createSlice } from '@reduxjs/toolkit';
import {
	importExpenseGroupAllocationCsvAction,
	fetchExpenseGroupAllocationsAction,
	upsertExpenseGroupAllocationsBatchAction,
} from 'redux/action/expenseGroupAllocationAction';
import { updateCurrentTab } from './transactionSlice';

const initialState = {
	isLoading: false,
	importResult: null as any,
	currentItems: [] as any[],
	accounts: [] as string[],
	singleAccountModeByGroup: {} as Record<string, boolean>, // Store single account mode state per expense group
	error: null as any,
	// Temporary configuration for Expense Allocation tab
	temporaryConfig: null as {
		expenseGroupId: string;
		configAccounts: string[];
		items: Array<{
			percentage: number;
			customerId?: string;
			customerName?: string;
			classId?: string;
			className?: string;
			locationId?: string;
			locationName?: string;
		}>;
		singleAccountMode?: boolean;
	} | null,
};

const expenseGroupAllocationSlice = createSlice({
	name: 'expenseGroupAllocation',
	initialState,
	reducers: {
		clearImportResult: (state) => {
			state.importResult = null;
			state.error = null;
		},
		setSingleAccountMode: (
			state,
			action: { payload: { expenseGroupId: string; value: boolean } }
		) => {
			state.singleAccountModeByGroup[action.payload.expenseGroupId] =
				action.payload.value;
		},
		setTemporaryConfig: (
			state,
			action: {
				payload: {
					expenseGroupId: string;
					configAccounts: string[];
					items: Array<{
						percentage: number;
						customerId?: string;
						customerName?: string;
						classId?: string;
						className?: string;
						locationId?: string;
						locationName?: string;
					}>;
					singleAccountMode?: boolean;
				} | null;
			}
		) => {
			state.temporaryConfig = action.payload;
		},
		clearTemporaryConfig: (state) => {
			state.temporaryConfig = null;
		},
		setAllocations: (
			state,
			action: {
				payload: {
					allocations: any[];
					accounts: string[];
				};
			}
		) => {
			state.currentItems = action.payload.allocations || [];
			state.accounts = action.payload.accounts || [];
		},
	},
	extraReducers: (builder) => {
		builder.addCase(importExpenseGroupAllocationCsvAction.pending, (state) => {
			// state.isLoading = true;
			state.error = null;
		});
		builder.addCase(
			importExpenseGroupAllocationCsvAction.fulfilled,
			(state, action) => {
				state.isLoading = false;
				state.importResult = action.payload;
			}
		);
		builder.addCase(
			importExpenseGroupAllocationCsvAction.rejected,
			(state, action: any) => {
				state.isLoading = false;
				state.error = action.payload || action.error;
			}
		);

		builder.addCase(fetchExpenseGroupAllocationsAction.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(
			fetchExpenseGroupAllocationsAction.fulfilled,
			(state, action) => {
				state.isLoading = false;
				const payload = action.payload as any;
				state.currentItems = payload?.allocations || [];
				state.accounts = payload?.accounts || [];
			}
		);
		builder.addCase(
			fetchExpenseGroupAllocationsAction.rejected,
			(state, action: any) => {
				state.isLoading = false;
				state.error = action.payload || action.error;
			}
		);

		builder.addCase(
			upsertExpenseGroupAllocationsBatchAction.pending,
			(state) => {
				state.isLoading = true;
			}
		);
		builder.addCase(
			upsertExpenseGroupAllocationsBatchAction.fulfilled,
			(state) => {
				state.isLoading = false;
			}
		);
		builder.addCase(
			upsertExpenseGroupAllocationsBatchAction.rejected,
			(state, action: any) => {
				state.isLoading = false;
				state.error = action.payload || action.error;
			}
		);

		// Clear temporary config whenever tab is updated
		builder.addCase(updateCurrentTab, (state) => {
			state.temporaryConfig = null;
		});
	},
});

export const {
	clearImportResult,
	setSingleAccountMode,
	setTemporaryConfig,
	clearTemporaryConfig,
	setAllocations,
} = expenseGroupAllocationSlice.actions;
export default expenseGroupAllocationSlice;
